import React, { useState } from 'react';
import { Form, Button, Alert, Card, Col, Row } from 'react-bootstrap';
import api from 'helpers/api';
import Logo from 'components/common/LogoLogin';
import Section from 'components/common/Section';
import { useParams } from 'react-router-dom'; // Para capturar o ID do usuário da URL

const NovaSenha = () => {
  const { token } = useParams(); // Captura o ID do usuário da URL
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarSenha, setConfirmarSenha] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (novaSenha !== confirmarSenha) {
      setError('As senhas não coincidem.');
      return;
    }

    try {
      const response = await api.post(`/api/nova-senha`, { token, novaSenha });
      setMessage(response.data.message); // Mensagem de sucesso do backend
      // Aguarda 5 segundos e redireciona para a página de login
      if (response.status === 200) {
        setTimeout(() => {
          window.location.href = '/'; // Altere para a rota correta do seu aplicativo
        }, 5000);
      }
    } catch (err) {
      if (err.response && err.response.data) {
        setError(err.response.data.message || 'Erro ao atualizar a senha.');
      } else {
        setError(err.response.data.message);
      }
    }
  };

  const videoContainerStyle = {
    position: 'fixed', // Fixa o vídeo na viewport
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: -1, // Coloca o vídeo atrás de outros elementos
    overflow: 'hidden' // Esconde partes do vídeo que excedem o container
  };

  const iframeStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100vw', // Garante que cubra a largura
    height: '56.25vw', // Mantém a proporção 16:9 (100 / 16 * 9)
    minHeight: '100vh', // Garante que cubra a altura mínima
    minWidth: '177.77vh', // Garante que cubra a largura mínima (100 / 9 * 16)
    transform: 'translate(-50%, -50%)', // Centraliza o vídeo
    pointerEvents: 'none' // Impede interação com o vídeo
  };

  const videoUrl =
    'https://www.youtube.com/embed/wllYbJSnV8U?enablejsapi=1&disablekb=1&controls=0&rel=0&iv_load_policy=3&cc_load_policy=0&playsinline=1&showinfo=0&modestbranding=1&fs=0&origin=https://voxgroupbrasil.com&mute=1&autoplay=1&loop=1&playlist=wllYbJSnV8U'; // Adicionado playlist=VIDEO_ID para loop funcionar

  return (
    <Section
      className="py-0"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      {' '}
      {/* Necessário para posicionamento absoluto do filho */}
      {/* Container do Vídeo */}
      <div style={videoContainerStyle}>
        <iframe
          style={iframeStyle}
          src={videoUrl}
          title="YouTube video background"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5}>
          <Card style={{ backgroundColor: 'rgba(255, 255, 255, 0.15)', backdropFilter: 'blur(70px)' }}>
            <Logo width={300} className="mt-3" />
            <Card.Body className="p-4 p-sm-5">
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  {/* <Form.Label>Nova Senha</Form.Label> */}
                  <Form.Control
                    type="password"
                    placeholder="Nova Senha"
                    value={novaSenha}
                    onChange={e => setNovaSenha(e.target.value)}
                    required                    
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  {/* <Form.Label>Confirmar Senha</Form.Label> */}
                  <Form.Control
                    type="password"
                    placeholder="Confirmar Senha"
                    value={confirmarSenha}
                    onChange={e => setConfirmarSenha(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit">
                  Atualizar Senha
                </Button>
              </Form>
              {message && (
                <Alert variant="success" className="mt-3">
                  {message}
                </Alert>
              )}
              {error && (
                <Alert variant="primary" className="mt-3">
                  {error}
                </Alert>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default NovaSenha;
